import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./HomeLearnMore.scss";
import Slider from "react-slick";
import { useTranslation } from "react-i18next";
import { homeLearnMoreSliderData } from "./homeLearnMoreData";

const HomeLearnMore = () => {
  const { t } = useTranslation();

  const renderSlideItem = (item: { id: number; title: string; text: string; imagePath: any }) => {
    return (
      <div key={item.id}>
        <div className={"item"}>
          <img className={"image"} src={item.imagePath} alt={item.title} />
          <div>
            <h2 className={"title"}>{t(item.title)}</h2>
            <p dangerouslySetInnerHTML={{ __html: t(item.text) }} className={"text"}></p>
          </div>
        </div>
      </div>
    );
  };

  const settings = {
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    appendDots: (dots: any) => <ul className={"dots-wrapper"}>{dots}</ul>,
    customPaging: () => <div className={"dot"}></div>,
  };

  return (
    <div className={"home-learn-more"}>
      <div className="container">
        <Slider {...settings}>{homeLearnMoreSliderData.map((el) => renderSlideItem(el))}</Slider>
      </div>
    </div>
  );
};

export default HomeLearnMore;
